import TitlePlaceholder from "./Title.Placeholder";
import ParagraphPlaceholder from "./Paragraph.Placeholder";
import { ReactComponent as ImgPlaceholder } from "./imgplaceholder.svg";

export default { TitlePlaceholder, ParagraphPlaceholder, ImgPlaceholder };
